import React from 'react';
import PropTypes from 'prop-types';
import { refSetter } from '../../../utils/helpers';

const POSITION = {
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  CUSTOM: 'custom',
};

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      positionSettings: {
        top: 0,
        left: 0,
        class: '',
      },
    };
  }

  setRef = refSetter.bind(this);

  toggleTooltip = e => {
    if (!this.state.visible) {
      this.setState({ visible: true });
      this.setState({ positionSettings: this.calculatePosition(this.wrapperRef) });
      document.addEventListener('click', this.toggleTooltip);
    } else {
      e.stopPropagation();
      if (this.tooltipRef && !this.tooltipRef.contains(e.target)) {
        this.setState({ visible: false });
        document.removeEventListener('click', this.toggleTooltip);
      }
    }
  };

  generateStyle = () => ({
    display: this.state.visible ? 'block' : 'none',
    left: this.state.positionSettings.left,
    top: this.state.positionSettings.top,
  });

  calculatePosition = node => {
    const { placement } = this.props;
    const position = {
      top: 0,
      left: 0,
    };
    const element = node.getBoundingClientRect();
    switch (placement) {
      case POSITION.BOTTOM:
        position.left = element.width / 2;
        position.top = element.height;
        position.class = 'tooltip-bottom';
        break;

      case POSITION.RIGHT:
        position.left = element.width;
        position.top = element.height / 2;
        position.class = 'tooltip-right';
        break;

      case POSITION.LEFT:
        position.top = element.height / 2;
        position.class = 'tooltip-left';
        break;

      default:
      case POSITION.TOP:
        position.left = element.width / 2;
        position.class = 'tooltip-top';
        break;

      case POSITION.CUSTOM:
        position.top = element.height;
        position.left = '-10px';
        position.class = 'tooltip-custom';
        break;
    }
    return position;
  };

  render() {
    const { content, children } = this.props;
    const { positionSettings } = this.state;

    return (
      <div onClick={this.toggleTooltip} ref={this.setRef('wrapperRef')} role="presentation" className="tooltip-wrapper">
        {children}
        <div
          ref={this.setRef('tooltipRef')}
          className={`tooltip ${positionSettings.class}`}
          style={this.generateStyle()}
        >
          <div className="tooltip-arrow" />
          <div className="tooltip-arrow-shadow" />
          <div className="tooltip-content">{content}</div>
        </div>
      </div>
    );
  }
}

Tooltip.defaultProps = {
  placement: 'top',
  content: '',
};

Tooltip.propTypes = {
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'custom']),
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node.isRequired,
};

export default Tooltip;
